export const statusLabel = (status) => {
  switch (status) {
    case "p":
      return "Pending"
    case "b":
      return "Blocked"
    case "a":
      return "Approved"
    default:
      return "No Status"
  }
}

export const tagColorByStatus = (status) => {
  switch (status) {
    case "Draft":
      return "#f50"
    case "Pending":
      return "#2db7f5"
    case "Published":
      return "#87d068"
    default:
      return "#ccc"
  }
}